import React, { Component } from 'react';
import _ from 'lodash';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getLocalUserState } from '../redux/selectors/authentication';

const AuthorizationHOC = ( allowedPermissions ) => (WrappedComponent) => {

  const ErrorPage = <Redirect to="/errors/403" />;

  class Authorization extends Component {

    render() {

      if( _.isEmpty( this.props.localUser ) ) {
        return <Redirect to="/login" />
			}

			const permissions = this.props.localUser.permissions.map(x => x.name);
			
      if( _.intersection( allowedPermissions, permissions ).length > 0 ) {
        return <WrappedComponent {...this.props} />;
      }
      
      return ErrorPage;
    }
  }

  return connect(
    state => ({ localUser: getLocalUserState(state) })
  )(Authorization);

}

export default AuthorizationHOC;